module.exports = __webpack_public_path__ + "4a53203f9d711da769b557d3843d0d08.jpg";